<template>
  <div class="month">
    <pu-utc-date
      class="title"
      :options="{ month: monthFormat }"
      :date="titleMonth"
    />
    <pitchtype-mini-availability-calendar-week
      v-for="(week, index) of weeks"
      :key="`${month}-${index}`"
      :days="week"
      :parent-key="`${month}-${index}`"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PitchtypeMiniAvailabilityCalendarDayWithStatusesInfo } from '../schemas'

@Component
class PitchtypeMiniAvailabilityCalendarMonth extends Vue {
  @Prop({ required: true })
  month: number

  @Prop({ required: true })
  days: PitchtypeMiniAvailabilityCalendarDayWithStatusesInfo[]

  @Prop({ default: 'long' })
  monthFormat: string

  get titleMonth() {
    // this.month is a UTC timestamp - convert directly to first day of month
    // Use the timestamp directly to avoid server/client timezone differences
    return new Date(+this.month).toISOString()
  }

  get weeks() {
    // TODO: Add proper type for reduce accumulator
    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return -- Legacy reduce with untyped accumulator */
    const defaultState: { week: number; results: any[] } = {
      week: -1,
      results: [],
    }
    const totalListOfDays = [...this.skipDaysList, ...this.days]

    const result = totalListOfDays.reduce((acc, day, index) => {
      const results = [...acc.results]

      if (index % 7 === 0) {
        results.push([day])
        return { week: acc.week + 1, results }
      }
      results[acc.week].push(day)

      return { ...acc, results }
    }, defaultState).results
    return result
    /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return */
  }

  private getSkipDaysAmountBeforeMon(date: Date) {
    return (
      (new Date(
        Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1),
      ).getUTCDay() +
        6) %
      7
    )
  }

  private get skipDaysList(): null[] {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Array.fill returns any[] when used with null
    return new Array(
      this.getSkipDaysAmountBeforeMon(new Date(this.days[0].date)),
    ).fill(null)
  }
}

export default toNative(PitchtypeMiniAvailabilityCalendarMonth)
</script>

<style scoped>
.month {
  display: flex;
  flex-direction: column;
}

.title {
  color: var(--colour-text-light);
  font-size: var(--tiny);
  font-weight: normal;
  line-height: 1;
  margin-bottom: 3px;
}
</style>
